var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BDStatusPill,{staticClass:"status-pill",attrs:{"color":_setup.STATUS_COLORS[_vm.status] || 'grey',"label":_setup.complianceStatusLabels[_vm.status]}})
}
var staticRenderFns = []

export { render, staticRenderFns }